import PolicyLayout from './PolicyLayout';
import { Zap } from 'lucide-react';

export default function ShippingPolicyPage() {
  return (
    <PolicyLayout
      title="Shipping Policy"
      subtitle="How DotCall delivers its digital services."
    >
      <div className="rounded-xl bg-emerald-600/[0.08] border border-emerald-500/25 p-5 mb-6 flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-emerald-600/20 flex items-center justify-center flex-shrink-0 mt-0.5">
          <Zap className="w-4 h-4 text-emerald-300" />
        </div>
        <div>
          <p style={{ marginBottom: 0, color: 'rgba(255,255,255,0.9)', fontWeight: 500 }}>
            <strong>DotCall is a 100% digital SaaS product — no physical shipping involved.</strong>
            {' '}Your services are provisioned instantly after payment.
          </p>
        </div>
      </div>

      <h2>1. Digital-Only Product</h2>
      <p>
        DotCall is a Software-as-a-Service (SaaS) platform for AI voice agents. We do not sell, manufacture,
        or ship any physical goods. All products and services offered by DotCall — including dashboard access,
        AI voice agents, phone numbers, call minutes, wallet credits, and integrations — are
        <strong> delivered electronically</strong> through our platform.
      </p>

      <h2>2. Instant Delivery</h2>
      <p>Once your payment is successfully processed by our payment partner (Razorpay):</p>
      <ul>
        <li><strong>Subscription activation</strong> happens <strong>instantly</strong> — typically within a few
          seconds. Your dashboard is updated in real time with the features and minute allowances of your
          chosen plan.</li>
        <li><strong>Wallet top-ups</strong> are credited to your DotCall wallet <strong>immediately</strong>
          upon successful payment verification.</li>
        <li><strong>Phone numbers</strong> purchased through the platform are provisioned from Twilio and
          assigned to your account typically within 1–2 minutes.</li>
      </ul>

      <h2>3. Delivery Confirmation</h2>
      <p>You will receive:</p>
      <ul>
        <li>An on-screen confirmation in the DotCall dashboard.</li>
        <li>An email receipt to your registered email address with the payment reference and plan details.</li>
        <li>A corresponding entry in your wallet transaction history (visible under <em>Dashboard → Settings → Billing</em>).</li>
      </ul>

      <h2>4. No Shipping Fees</h2>
      <p>Since no physical product is shipped, <strong>no shipping or delivery charges</strong> apply to any
        order placed on DotCall. The price you see at checkout is the total price (exclusive of GST, which is
        displayed separately on the invoice).</p>

      <h2>5. Delivery Delays</h2>
      <p>In rare cases, a payment may be debited from your bank account but not immediately credited to your
        DotCall account due to payment-gateway processing delays or network issues. This is typically resolved
        automatically within a few minutes to a few hours. If a successful payment is not reflected in your
        account within <strong>24 hours</strong>, please contact support with your payment reference number
        and we will investigate promptly.</p>

      <h2>6. Service Availability</h2>
      <p>DotCall services are accessible globally over the internet. However, voice-calling features are
        primarily optimized for Indian telephony via Twilio Indian numbers. Availability of specific features
        and integrations may vary by region and regulatory approvals.</p>

      <h2>7. Contact</h2>
      <p>If you have any questions about digital delivery or cannot access your purchased services, please
        contact us at <strong>support@dotcall.io</strong> or <strong>+91 88798 51335</strong>. Our support
        team is available Monday through Saturday, 10:00 AM to 7:00 PM IST.</p>
    </PolicyLayout>
  );
}
